export enum DocumentationFileAntivirusResult {
	UNPROCESSED = 'unprocessed',
	CLEAN = 'clean',
	INFECTED = 'infected',
	OTHER = 'other',
}
